import { Component, Inject, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { remove } from 'lodash';

export interface ManageBackupsDialogResult{
  delete: boolean,
  filesToDelete: string[]
}

@Component({
  selector: 'app-manage-backups-dialog',
  templateUrl: './manage-backups-dialog.component.html',
  styleUrls: ['../shared/styles/styles.css']
})

export class ManageBackupsDialogComponent implements OnInit {

  filesToDelete: string[] = [];
  isEmpty = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ManageBackupsDialogComponent>) {}
  
  ngOnInit(): void { if (this.data.elements.length === 1) this.isEmpty = this.data.elements[0] === 'config.json' ? true : false; }

  close() { this.dialogRef.close(this.createDialogResult(true)); }
  cancel() { this.dialogRef.close(this.createDialogResult(false)); }

  checkBoxChange(event: MatCheckboxChange){
    const value = event.source.value;
    event.checked ? this.filesToDelete.push(value) : remove(this.filesToDelete, arrValue => arrValue === value)
  }

  private createDialogResult(isDelete: boolean): ManageBackupsDialogResult{
    if (this.filesToDelete.length === 0) isDelete = false;
    return {
      delete: isDelete,
      filesToDelete: this.filesToDelete
    }
  }
}